import React, { useState, useContext, useLayoutEffect } from 'react';

import * as S from './styles';
import SimpleInput from 'components/SimpleInput';
import SelectInput from 'components/SelectInput';
import { optionsRedirectType } from 'utils/optionsInputs';
import { SelectInputItemProps } from 'types/SelectInputItemProps';
import DynamicPageContext from 'context/DynamicPage';
import { verifyIfFormCanSave } from './functions';
export interface DataFormProps {
	redirect: {
		value: string;
		type: string;
	};
	redText: string;
	boldTitle: string;
	text: string;
	buttonLabel: string;
}

const initialData = {
	redirect: {
		value: '',
		type: ''
	},
	redText: '',
	boldTitle: '',
	text: '',
	buttonLabel: ''
};

export default function InputsPopUp() {
	const {
		moduleInSavingMode,
		setModuleInSavingMode,
		setCanSaveModuleOnBack,
		setMessageErrorForm,
		moduleOnPhoneToEdit,
		setModuleOnPhoneToEdit
	} = useContext(DynamicPageContext);

	const [dataForm, setDataForm] = useState(initialData);

	function findOptionOnListById(value: string, list: SelectInputItemProps[]) {
		const itemsList = list.filter((item) => item.id === value);
		if (itemsList.length > 0) {
			return itemsList[0];
		}

		return '';
	}

	useLayoutEffect(() => {
		//se esta criando um novo componente
		if (moduleInSavingMode !== null) {
			setModuleInSavingMode((obj) => {
				if (obj) {
					return { ...obj, data: dataForm };
				}
				return obj;
			});
		} else {
			//se esta editando um componente
			setModuleOnPhoneToEdit((obj) => {
				if (obj) {
					return { ...obj, data: dataForm };
				}
				return obj;
			});
		}

		verifyIfFormCanSave(dataForm, setCanSaveModuleOnBack, setMessageErrorForm);
	}, [dataForm]);

	//se estiver em edição aqui pega os dados do item editado
	useLayoutEffect(() => {
		if (moduleOnPhoneToEdit !== null && moduleInSavingMode === null) {
			setTimeout(() => {
				setDataForm((obj) => ({ ...obj, ...moduleOnPhoneToEdit.data }));
			}, 100);
		}
	}, []);

	return (
		<S.container>
			<S.twoInputs>
				<SimpleInput
					label="Label do botão *"
					initialValue={dataForm.buttonLabel}
					getValue={(value: string) => {
						setDataForm((obj) => ({ ...obj, buttonLabel: value }));
					}}
				/>

				<SimpleInput
					label="Texto "
					initialValue={dataForm.text}
					getValue={(value: string) => {
						setDataForm((obj) => ({ ...obj, text: value }));
					}}
				/>
			</S.twoInputs>

			<SelectInput
				list={optionsRedirectType}
				getValue={(value: SelectInputItemProps | '') => {
					setDataForm((obj) => ({
						...obj,
						redirect: {
							...obj.redirect,
							type: value === '' ? value : (value?.id as string)
						}
					}));
				}}
				initialValue={
					dataForm.redirect.type === ''
						? ''
						: findOptionOnListById(
								dataForm.redirect.type || '',
								optionsRedirectType
							)
				}
				label="Tipo redirecionamento *"
			/>

			<SimpleInput
				label="Valor de redirecionamento *"
				initialValue={dataForm.redirect.value}
				getValue={(value: string) => {
					setDataForm((obj) => ({
						...obj,
						redirect: { ...obj.redirect, value: value }
					}));
				}}
			/>

			<S.twoInputs>
				<SimpleInput
					label="Texto vermelho"
					initialValue={dataForm.redText}
					getValue={(value: string) => {
						setDataForm((obj) => ({ ...obj, redText: value }));
					}}
				/>

				<SimpleInput
					label="Texto bold"
					initialValue={dataForm.boldTitle}
					getValue={(value: string) => {
						setDataForm((obj) => ({ ...obj, boldTitle: value }));
					}}
				/>
			</S.twoInputs>
		</S.container>
	);
}
